(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("dashboardAdmin", {
        templateUrl: "app/dashboard/dashboardAdmin.component.html",
        controller: ["dashboardResource", "accountDashboardResource", "messageService", "$state", DashboardAdminCtrl],
        controllerAs: "vm"
    });
    function DashboardAdminCtrl(dashboardResource, accountDashboardResource, messageService, $state) {
        var vm = this;
        vm.loading = true;
        vm.isReadOnly = $state.params.isReadOnly;
        if (vm.isReadOnly) {
            dashboardResource.getAdminViewModel({ personSeq: $state.params.personSeq }, function (data) {
                vm.data = data;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
        }
        else {
            accountDashboardResource.getAdminViewModel(function (data) {
                vm.data = data;
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
        }
        /////////////////////////////////////////////////////////////
        vm.loadRecentUsers = function () {
            if (!vm.isReadOnly)
                $state.go("main.dashboardAdminRecentUsers");
        };
        vm.loadCompletions = function () {
            if (!vm.isReadOnly) {
                $state.go("main.dashboardGroupAdminCompleted");
            }
        };
        vm.loadExpiring = function () {
            if (!vm.isReadOnly)
                $state.go("main.dashboardGroupAdminExpiring");
        };
    }
}());
